import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import MobileShell, { useMobileLocation, BigButton } from "./MobileShell";

const FIELDS = [
  ["first_name", "First name *", "text", "given-name"], ["last_name", "Last name", "text", "family-name"],
  ["company", "Company", "text", "organization"], ["email", "Email", "email", "email"], ["phone", "Phone", "tel", "tel"],
];
const input = "w-full bg-white border border-brand-border rounded-xl px-4 py-3.5 text-base focus:outline-none focus:border-brand-ink";

export default function MLead() {
  const { locations, location } = useMobileLocation();
  const nav = useNavigate();
  const [f, setF] = useState({ first_name: "", last_name: "", company: "", email: "", phone: "", location, desks: "", tour_date: "", notes: "" });
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (location) setF((p) => (p.location ? p : { ...p, location })); }, [location]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async () => {
    if (!f.first_name.trim()) { toast.error("First name is required"); return; }
    if (!f.location) { toast.error("Pick a location"); return; }
    setSaving(true);
    try {
      await api.post("/crm/leads", { ...f, stage: f.tour_date ? "Tour Booked" : "New", source: "Walk-in / Hub app",
        desks: f.desks === "" ? null : Number(f.desks), tour_date: f.tour_date ? new Date(f.tour_date).toISOString() : null });
      toast.success(`${f.first_name} added to the CRM`);
      nav("/m");
    } catch (e) { toast.error("Couldn't add lead", { description: e.userMessage }); }
    finally { setSaving(false); }
  };
  return (
    <MobileShell title="New lead">
      <div className="space-y-3" data-testid="m-lead-form">
        {FIELDS.map(([k, label, type, ac]) => (
          <input key={k} type={type} autoComplete={ac} placeholder={label} value={f[k]} onChange={set(k)} className={input} data-testid={`m-lead-${k}`} />
        ))}
        <select value={f.location} onChange={set("location")} className={input} data-testid="m-lead-location">
          <option value="">Location *</option>
          {locations.map((l) => <option key={l} value={l}>{l}</option>)}
        </select>
        <input type="number" inputMode="numeric" placeholder="Desks needed" value={f.desks} onChange={set("desks")} className={input} data-testid="m-lead-desks" />
        <label className="block text-xs text-brand-tertiary px-1">Tour date & time (optional — adds them as Tour Booked)
          <input type="datetime-local" value={f.tour_date} onChange={set("tour_date")} className={`${input} mt-1`} data-testid="m-lead-tour" />
        </label>
        <textarea rows={3} placeholder="Notes" value={f.notes} onChange={set("notes")} className={input} data-testid="m-lead-notes" />
        <BigButton onClick={save} disabled={saving} className="bg-brand-primary text-brand-page" data-testid="m-lead-save">{saving ? "Saving…" : "Add lead"}</BigButton>
      </div>
    </MobileShell>
  );
}
